export const CDR = {
	GET_CALL_HISTORY: 'CDR_GET_CALL_HISTORY',
	SET_CALL_HISTORY: 'CDR_SET_CALL_HISTORY',
	SET_CALL_HISTORY_PAGINATION: 'CDR_SET_CALL_HISTORY_PAGINATION',
	SET_TO_FROM: 'CDR_SET_TO_FROM',
};
